module.exports = __webpack_public_path__ + "img/logo-nacion-mexicana.a0ea73a6.png";